<template>
    <BaseDialog
        :showDialog="showExportWorksDialog"
        maxDialogWidth="1200"
        maxCardHeight="800"
        headline="lang_GENERIC_CAPTION_EXPORT"
        :close="closeDialog"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid v-if="!showResult">
                <v-row>
                    <v-col cols="3" class="d-flex align-end pt-0">
                        <BaseEditPageDropdown 
                                :context="context"
                                field="Type" 
                                :items="typeItems" 
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_TYPE')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-type'"
                                :additionalFunction="clearButtons"
                            />
                        <div class="ml-2" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                            <ContextHelpIcon
                                v-if="type === 'CWR'"
                                context="PublishingWorksActionExportCWR"
                                :alvqa="alvqa + '-context-help-icon-cwr'"
                            />
                            <ContextHelpIcon
                                v-if="type === 'mappings'"
                                context="PublishingWorksMappingExport"
                                :alvqa="alvqa + '-context-help-icon-mappings'"
                            />
                        </div>
                    </v-col>
                </v-row>


                <v-row v-if="type === 'CWR'">
                    <v-col cols="5">
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_MERGE_TO_CA')" 
                                valueOuter="maestro"
                                hideDetails
                                class="mt-0"
                                :alvqa="alvqa + '-cwr-checkbox-maestro'"
                            />
                    </v-col>
                    <v-col>
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_ONLY_TO_BE_REGISTERED')" 
                                valueOuter="toBeRegisteredOnly"
                                class="mt-0"
                                hideDetails
                                :alvqa="alvqa + '-cwr-checkbox-registered-only'"
                            />
                    </v-col>
                </v-row>

                <v-row v-if="type === 'CWR'">
                    <v-col cols="5">
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_SKIP_GHOSTWORKS')" 
                                valueOuter="noGhost"
                                class="mt-0"
                                hideDetails
                                :alvqa="alvqa + '-cwr-checkbox-no-ghost'"
                            />
                    </v-col>
                    <v-col>
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_SKIP_STATUS2WORKS')" 
                                valueOuter="noStatus2"
                                class="mt-0"
                                hideDetails

                                :alvqa="alvqa + '-cwr-checkbox-no-status-2'"
                            />
                    </v-col>
                </v-row>

                <v-row v-if="type === 'CWR'">
                    <v-col cols="5">
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_PMR')" 
                                valueOuter="cwrMr100"
                                class="mt-0"
                                hideDetails
                                :iconTooltipText="$t('lang_PUBLISHING_WORKS_CAPTION_CWR_PMR_100_TOOLTIP')"
                                :alvqa="alvqa + '-cwr-checkbox-mr-100'"
                            />
                    </v-col>
                    <v-col cols="7">
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_NO_PWR_FOR_OPU')" 
                                valueOuter="noPwrForOpu"
                                class="mt-0"
                                hideDetails
                                :alvqa="alvqa + '-no-pwr-for-opu'"
                            />
                    </v-col>
                    <!-- versteckte alvqa für caro / gi -->
                    <!-- <span alvqa="cwr-export-ohne-status2">3</span> -->
                    <!-- value 3 as a result of cwr generation, write to span -->
                </v-row>

                <v-row v-if="type === 'CWR'">
                    <v-col cols="5">
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_CWR_EXPORT_NAT')" 
                                valueOuter="exportNAT"
                                class="mt-0"
                                hideDetails
                                :alvqa="alvqa + '-cwr-checkbox-export-nat'"
                            />
                    </v-col>
                    <v-col cols="7" v-if="cwrFileVersion === 'V22'">
                        <BaseCheckbox 
                                :context="context+type"
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_CWR_SPLIT_COPUB_WRITERS')" 
                                valueOuter="splitCopubWriters"
                                class="mt-0"
                                hideDetails
                                :alvqa="alvqa + '-cwr-checkbox-split-copub-writers'"
                            />
                    </v-col>
                </v-row>

                <v-row v-if="type === 'mappings'">
                    <v-col cols="6">
                        <BaseEditPageDropdown 
                                :context="context"
                                field="MappingId"
                                :items="exportMappingsList"
                                :label="$t('lang_GENERIC_CAPTION_ABBREVIATION')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-interested-parties'"
                            />
                    </v-col>
                    <v-col cols="6">
                        <BaseEditPageDropdown 
                                :context="context"
                                field="MappingSource"
                                :items="exportMappingSources"
                                :label="$t('lang_GENERIC_CAPTION_SOURCE')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :iconTooltipText="$t('lang_PUBLISHING_WORKS_CAPTION_EXPORT_SOURCE_INFO')"
                                :alvqa="alvqa + '-dropdown-mapping-source'"
                            />
                    </v-col>
                </v-row>

                <v-row v-if="type === 'JWR'">
                    <v-col cols="6">
                        <BaseEditPageDropdown
                            :context="context"
                            :field="'JwrSubmitter'"
                            :items="JwrSubmitterItems"
                            :label="$t('lang_PUBLISHING_WORKS_CAPTION_JWR_SUBMITTER')"
                            :selection="true"
                            :withMargin="false"
                            :clearable="false"
                            hideDetails
                            :alvqa="alvqa + '-jwr-dropdown-submitter'"
                        />
                    </v-col>
                </v-row>

                <!-- CWR only -->
                <v-row v-if="type === 'CWR'">

                    <!-- only OVW, SVW or "all" = no check of type -->
                    <v-col cols="2">
                            <BaseEditPageDropdown
                                :context="context"
                                :field="'ShareType'"
                                :items="ShareTypeItems"
                                :label="$t('lang_PUBLISHING_CAPTION_SHARE_TYPE')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                valueOuter="shareTypeOuter"
                                :additionalFunction="switchListOfPublishers"
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-share-type'"
                                rules="required"
                            />
                        </v-col>
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                                :context="context"
                                :field="'ExportWorksTypes'+type"
                                :items="exportWorksTypes"
                                :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_WORKS_TYPES')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-works-types'"
                            />
                    </v-col>

                    <v-col cols="2">
                        <BaseEditPageDropdown 
                                :context="context"
                                :field="'InterestedParties'+type"
                                :items="addSEandCollPercentItems"
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_ADD_SE_AND_COLL')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="false"
                                :alvqa="alvqa + '-dropdown-interested-parties'"
                            />
                    </v-col>

                    <v-col cols="4">
                        <BaseEditPageDropdown 
                                :context="context"
                                :field="'PseudoSlg'"
                                :items="exportWorksPseudoSlgOptions"
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_PSEUDO_SLG')"
                                :selection="true"
                                :withMargin="false"
                                hideDetails
                                :clearable="true"
                                :disabled="isPseudoSlgDisabled"
                                :additionalFunction="onPseudoSlgChange"
                                :alvqa="alvqa + '-dropdown-works-pseudo-slg'"
                            />
                    </v-col>

                </v-row>

                <v-row v-if="type === 'CWR'">
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                            :context="context"
                            :field="'CwrRecipient'"
                            :items="cwrRecipientsList"
                            :label="$t('lang_CONTRACTS_PUBLISHING_EDIT_WORKS_PANEL_EXPORT_CWR_LABEL_RECIPIENT_SOCIETY')"
                            :selection="true"
                            :withMargin="false"
                            :clearable="false"
                            hideDetails
                            :alvqa="alvqa + '-cwr-dropdown-recipient'"
                        />
                    </v-col>
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                            :context="context"
                            :field="'CwrSubmitter'"
                            :items="CwrSubmitterItems"
                            :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CWR_SUBMITTER')"
                            :selection="true"
                            :withMargin="false"
                            :clearable="false"
                            hideDetails
                            :alvqa="alvqa + '-cwr-dropdown-submitter'"
                        />
                        <div v-if="!hasCwrSubmitters" class="error--text mt-1 text-caption">
                            {{ $t('lang_PUBLISHING_WORKS_MESSAGE_ERROR_NO_CWR_SUBMITTER') }}
                        </div>
                    </v-col>
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                            :context="context"
                            :field="'CwrFileVersion'"
                            :items="cwrFileVersions"
                            :label="$t('lang_PUBLISHING_GENERIC_CAPTION_CWR_FILE_VERSION')"
                            :selection="true"
                            :withMargin="false"
                            :clearable="false"
                            hideDetails
                            :alvqa="alvqa + '-cwr-dropdown-file-version'"
                        />
                    </v-col>
                </v-row>

                <v-row v-if="isCwrJsonExport">
                    <v-col cols="4">
                        <BaseEditPageDropdown
                            :context="context"
                            field="Schema"
                            :items="cwrJsonSchemaItems"
                            :label="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_SCHEMA')"
                            :selection="true"
                            :withMargin="false"
                            hideDetails
                            :clearable="false"
                            :alvqa="alvqa + '-cwr-json-dropdown-schema'"
                        />
                    </v-col>
                </v-row>

                <v-row v-if="type === 'CWR'">
                    <v-col cols="4">
                        <BaseEditPageDropdown 
                            :context="context"
                            :field="'SelectedPublisherEntry'"
                            :items="exportPublisherEntries"
                            :label="$t('lang_PUBLISHING_WORKS_EXPORT_DYNAMIC_PUBLISHER_AFFILIATION')"
                            :selection="true"
                            :withMargin="false"
                            hideDetails
                        />
                    </v-col>
                    <v-col>
                        <BaseRegions 
                            :context="context"
                            includeLabel="lang_PUBLISHING_WORKS_EXPORT_INCLUDE_TERRITORY"
                            excludeLabel="lang_PUBLISHING_WORKS_EXPORT_EXCLUDE_TERRITORY"
                            :includeItems="includeItems"
                            :excludeItems="excludeItems"
                            cols="6"
                            :withMargin="false"
                            :clearable="false"
                            :alvqa="alvqa+'-cwr'"
                        />
                    </v-col>
                </v-row>

            </v-container>
            
            <v-container v-if="showResult">
                <v-row>
                    <v-col 
                        :alvqa="alvqa + '-result-text'"
                        v-html="$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CWR_GENERAL_ERROR_INCL_COLOR_DESCRIPTION')"
                    ></v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :headers="resultHeaders"
                            :items="resultArray"
                            hide-default-footer
                            disable-sort
                            dense
                            :items-per-page="itemsPerPage"
                        >
                            <template v-slot:item="{ item, index }">
                                <tr>
                                    <td>
                                        <v-chip
                                            small
                                            label
                                            :alvqa="alvqa + 'result-list-row-' + (index+1) + '-chip-error'"
                                            :color="item.level === 1 ? 'error' : 'warning'"
                                        >{{ $t('lang_GENERAL_CAPTION_ERROR') }}</v-chip>
                                    </td>
                                    <td 
                                        class="text-left ellipsis"
                                        :alvqa="alvqa + '-result-list-row-' + (index+1) + '-text-work-title'"
                                    >
                                        {{ item.workTitle }} ({{ item.alvId }})
                                    </td>
                                    <td 
                                        class="text-left"
                                        :alvqa="alvqa + '-result-list-row-' + (index+1) + '-text-error-message'"
                                    >
                                        {{ item.errorMsg }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid >
                <v-row>
                    <span v-if="resultLink !== null" alvqa='gi-cwr-export' style="display:none">{{ resultGi }}</span>
                    <v-spacer />
                    <v-col class="d-flex justify-end align-center gap-2">
                        <span 
                            v-if="resultLink !== null"
                            :alvqa="alvqa + '-text-download-file'" 
                        >{{ $t('lang_GENERIC_CAPTION_CLICK_HERE_TO_DOWNLOAD')}}
                        </span>
                        <span class="pr-4">
                            <BaseIcon 
                                v-if="resultLink !== null"
                                @click.stop="downloadFile()" 
                                icon="cloud_download" 
                                :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                                :alvqa="alvqa + '-icon-download-file'" 
                            />
                        </span>
                        <span
                            v-if="resultLink !== null && canPreviewCwr"
                            :alvqa="alvqa + '-text-preview-file'"
                        >{{ $t('lang_GENERAL_BUTTON_PREVIEW_CWR')}}</span>
                        <span class="pr-4" v-if="resultLink !== null && canPreviewCwr">
                            <BaseIcon
                                @click.stop="previewFile()"
                                icon="visibility"
                                :tooltipText="$t('lang_GENERAL_BUTTON_PREVIEW_CWR')" 
                                :alvqa="alvqa + '-icon-preview-file'"
                            />
                        </span>
                        <span>
                            <BaseButton 
                                label="lang_BUTTON_START"
                                @click="start"
                                :disabled="isLoading || !isInputValid"
                                :alvqa="alvqa+'-button-start'"
                            />
                        </span>
                            <!-- Download Button for CWR File -->
                            <!-- <BaseButton 
                                v-if="resultLink !== null"
                                icon="cloud_download"
                                :label="getFileName()"
                                @click="downloadFile()"
                                :alvqa="alvqa+'-button-cwr-file-download'"
                            /> -->
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseRegions from '@/components/_base/BaseRegions'
import BaseIcon from '@/components/_buttons/BaseIcon'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon.vue'
import api from '@/api_alv.js'
import { openCwrPreview } from '@/assets/helpers/cwrPlayground.js'
import {    DropdownPublishingWorksExportWorksTypes,
            DropdownGenericYesNoOpwSpw,
            DropdownPublishingWorksRegistrationShareTypes,
 } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ExportWorksDialog",
    components: {
        BaseDialog,
        BaseButton,
        BaseCheckbox,
        BaseEditPageDropdown,
        BaseRegions,
        BaseIcon,
        ContextHelpIcon
    },
    data() {
        return {
            context: "ExportWorks",
            alvqa: 'publishing-works-list-dialog-export-works'
        }
    },
    computed: {
        itemsPerPage() { return this.$store.getters.getItemsPerPage },

        showExportWorksDialog: {
            get() { return this.$store.getters.getShowExportWorksDialog },
            set(show) { this.$store.commit('setShowExportWorksDialog', show) }
        },
        isLoading()         { return this.$store.getters.getIsLoading },
        showResult()        { return this.$store.getters.getExportWorksShowResult },
        resultLink()        { return this.$store.getters.getExportWorksResultLink },
        resultGi()          { return this.$store.getters.getExportWorksResultGi },
        type()              { return this.$store.getters.getExportWorksDetailsType },
        cwrFileVersion()    { return this.$store.getters.getExportWorksDetailsCwrFileVersion },
        isCwrJsonExport()   { return this.type === 'CWR' && this.cwrFileVersion === 'CWR-JSON' },
        canPreviewCwr()     { return this.type === 'CWR' && !this.isCwrJsonExport && !this.$store.getters.getExportWorksHasError },
        resultArray()       { return this.$store.getters.getExportWorksErrorArray },
     
        exportWorksTypes()  { return DropdownPublishingWorksExportWorksTypes },

        includeItems() { 
            let storeIncludes = this.$alvPlugin.getListOfTranslatedCountries()
            storeIncludes.unshift({text: this.$t('lang_CAPTION_REGION_WORLD'), value: 'WORLD'})
            return storeIncludes
        },
        excludeItems() { return this.$alvPlugin.getListOfTranslatedCountries() },

        exportPublisherEntries() {
            return this.$store.getters.getExportPublisherEntries || [];
        },

        CwrSubmitterItems() { 
            let companies = this.$store.getters.getPublishingCompanies
            let items = []

            companies.forEach(company => {
                // Only add companies that have a CWR submitter code
                if (company.cwr && company.cwr.trim() !== '') {
                    items.push(
                        {
                            text: company.name, 
                            value: company.cwr+'#'+company.id, 
                            alvqa: this.alvqa + '-cwr-dropdown-submitter-' + company.name.toLowerCase().replace(/ /g,"-")
                        }
                    )
                }
            });
            if (items.length != 0)
                this.$store.commit('setExportWorksDetailsCwrSubmitter', items[0].value)
            return items
        },

        typeItems() {
            return [
                {text: this.$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_CWR'), value: 'CWR', alvqa: this.alvqa + '-dropdown-type-cwr'},
                {text: this.$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_JWR'), value: 'JWR', alvqa: this.alvqa + '-dropdown-type-jwr'},
                {text: this.$t('lang_ACCOUNT_MAPPINGS'), value: 'mappings', alvqa: this.alvqa + '-dropdown-type-mappings'},
            ]
        },

        JwrSubmitterItems() {
            let companies = this.$store.getters.getPublishingCompanies
            let items = []
            companies.forEach(company => {
                items.push({
                    text: company.name,
                    value: '#' + company.id,
                    alvqa: this.alvqa + '-jwr-dropdown-submitter-' + company.name.toLowerCase().replace(/ /g, "-")
                })
            })
            if (items.length != 0 && (this.$store.getters.getExportWorksDetailsJwrSubmitter === '' || this.$store.getters.getExportWorksDetailsJwrSubmitter == null)) {
                this.$store.commit('setExportWorksDetailsJwrSubmitter', items[0].value)
            }
            return items
        },

        cwrFileVersions() {
            return [
                {text: this.$t('lang_PUBLISHING_GENERIC_CAPTION_CWR_21'), value: 'V21', alvqa: this.alvqa + '-dropdown-type-cwr-v21'},
                {text: this.$t('lang_PUBLISHING_GENERIC_CAPTION_CWR_22'), value: 'V22', alvqa: this.alvqa + '-dropdown-type-cwr-v22'},
                {text: this.$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_JSON'), value: 'CWR-JSON', alvqa: this.alvqa + '-dropdown-type-cwr-json'}
            ]
        },

        cwrJsonSchemaItems() {
            return [{
                text: 'CWR-JSON v1.0 Schema',
                value: 'cwr-json-v1.0',
                alvqa: this.alvqa + '-cwr-json-schema-v1-0'
            }]
        },

        interestedPartiesItems() { 
            return [
                {text: this.$t('lang_WORKSEXPORT_IP_WITHOUT_SE'), value: 'without-se', alvqa: this.alvqa + '-dropdown-interested-parties-without-se'},
                {text: this.$t('lang_WORKSEXPORT_IP_WITH_SE'), value: 'with-se', alvqa: this.alvqa + '-dropdown-interested-parties-with-se'}
            ]
        },

        addSEandCollPercentItems() {
            let options = DropdownGenericYesNoOpwSpw

            let svWorkRegistrationModule = this.$store.getters.getUserModules.sv_work_registration
            if (svWorkRegistrationModule.active !== 'yes') {
                options = options.filter((el) => el.value == 'no')
            }

            return options
        },

        exportWorksPseudoSlgOptions() {
            let slgContracts = JSON.parse(JSON.stringify(this.$store.getters.getExportWorksSlgContracts)).list
            if (slgContracts != undefined) {
                let items = []
                slgContracts.forEach(contract => {
                    items.push(
                        {
                            text: contract.title, 
                            value: contract.alvId, 
                            alvqa: this.alvqa + '-pseudo-slg-dropdown-' + contract.alvId
                        }
                    )
                })
                return items
            } else {
                return []
            }
        },
        
        resultHeaders() {
            return [
                {
					text: '', 
					value: 'level', 
                    align: 'center',
                    width: "95px",
					class: 'text-no-wrap'
                },
                {
					text: this.$t('lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE'), 
                    value: 'workTitle', 
                    align: 'left',
					class: 'text-no-wrap'
                },
                {
					text: this.$t('lang_GENERAL_CAPTION_ERROR'), 
                    value: 'errorMsg', 
                    align: 'left',
                    class: 'text-no-wrap'
                },
            ]
        },

        exportMappingsList() {
            let mappingsList = this.$store.getters.getMappings
            let retArr = []
            mappingsList.forEach((v) => {
                if (v.direction !== 'export') return;
                 
                retArr.push({
                    value: v.alvId,
                    text: v.abbreviation,
                    alvqa: this.alvqa + `-export-mapping-${v.alvId}`
                })
            })
            return retArr
        },
        getDirectMembershipSocieties() {
            let data = this.$store.getters.getAzSocietiesWhereDirectMember
            let retArr = []
            // Prepare data for dropdown
            data.forEach((v) => {
                retArr.push({
                    value: v.alvId,
                    text: v.societyAcronym,
                    alvqa: this.alvqa + `-export-source-society-${v.societyAcronym}`
                })
            })

            return retArr
        },
        exportMappingSources() {
            let shareTypes = [
                {
                    text: 'ROLE%',
                    value: 'osRole',
                    alvqa: this.alvqa + '-export-mappings-source-original-share-role'
                },
                {
                    text: 'INTL%',
                    value: 'osIntl',
                    alvqa: this.alvqa + '-export-mappings-source-original-share-intl',
                },
                {
                    text: 'OWN%',
                    value: 'osOwn',
                    alvqa: this.alvqa + '-export-mappings-source-original-share-own',
                },
                {
                    text: 'MANU%',
                    value: 'osManu',
                    alvqa: this.alvqa + '-export-mappings-source-original-share-manu',
                }
            ]
            
            let societiesOfUser = this.getDirectMembershipSocieties

            return shareTypes.concat(societiesOfUser)
        },
        isInputValid() {
            if (this.type == 'mappings' && (this.$store.getters.getExportWorksDetailsMappingId == null || this.$store.getters.getExportWorksDetailsMappingSource == null)) {
                return false
            }
            
            // Disable Start button if CWR type is selected but no submitters with codes are available
            if (this.type === 'CWR' && this.hasCwrSubmitters === false) {
                return false
            }

            // JWR requires a submitting publishing company
            if (this.type === 'JWR' && (this.$store.getters.getExportWorksDetailsJwrSubmitter === '' || this.$store.getters.getExportWorksDetailsJwrSubmitter == null)) {
                return false
            }

            return true
        },
        isPseudoSlgDisabled() {
            return this.$store.getters.getUserModules.sv_work_registration.active !== 'yes'
        },

        ShareTypeItems()  { 
            return DropdownPublishingWorksRegistrationShareTypes 
        },
        getDefaultRecipientSociety() {
            let userInformation = JSON.parse(localStorage.getItem("userData"))['user']
            return userInformation.homeSocietyCode ? userInformation.homeSocietyCode : 0
        },
        cwrRecipientsList() {
            let recipientsList = this.$alvPlugin.cwrSocieties(true, this.alvqa + '-cwr-dropdown-recipient')
            if (this.$store.getters.getExportWorksDetailsExportWorksTypesCWR === 'exportUpwTypes') {
                this.$store.commit('setExportWorksDetailsCwrRecipient', 0)
                return recipientsList.filter(el => el.value === 0)
            }

            let homeSociety = parseInt(this.getDefaultRecipientSociety)

            if (recipientsList.some(el => el.value === homeSociety)) {
                this.$store.commit('setExportWorksDetailsCwrRecipient', homeSociety)
            }

            return recipientsList
        },
        hasCwrSubmitters() {
            return this.CwrSubmitterItems.length > 0
        },
        cwrExportFingerprint() {
            if (this.type !== 'CWR') {
                return ''
            }
            return JSON.stringify({
                checkboxes: this.$store.getters.getExportWorksCWRCheckbox,
                shareType: this.$store.getters.getExportWorksDetailsShareType,
                exportWorksTypes: this.$store.getters.getExportWorksDetailsExportWorksTypesCWR,
                interestedParties: this.$store.getters.getExportWorksDetailsInterestedPartiesCWR,
                pseudoSlg: this.$store.getters.getExportWorksDetailsPseudoSlg,
                cwrRecipient: this.$store.getters.getExportWorksDetailsCwrRecipient,
                cwrSubmitter: this.$store.getters.getExportWorksDetailsCwrSubmitter,
                cwrFileVersion: this.$store.getters.getExportWorksDetailsCwrFileVersion,
                schema: this.$store.getters.getExportWorksDetailsSchema,
                selectedPublisherEntry: this.$store.getters.getExportWorksDetailsSelectedPublisherEntry,
                include: this.$store.getters.getExportWorksDetailsInclude,
                exclude: this.$store.getters.getExportWorksDetailsExclude
            })
        }
    },
    watch: {
        cwrExportFingerprint() {
            if (this.resultLink != null) {
                this.invalidateExportResult()
            }
        },
        showExportWorksDialog(newVal) {
            if (newVal) {
                this.$store.dispatch('fetchAzSocietiesWhereDirectMember')
            }
        }
    },
    methods: {
        closeDialog() {
            this.showExportWorksDialog = false
            this.clearButtons()
        },
        switchListOfPublishers(shareType) {
            this.$store.commit('setExportWorksDetailsSelectedPublisherEntry', null)
            this.$store.commit('setExportWorksDetailsShareType', shareType)
            this.$store.dispatch('fetchExportPublisherEntries') // for Dynamic Society Affiliation
        },
        // PseudoSLG requires SV+COLL%; auto-set to avoid export errors (Bettina case).
        onPseudoSlgChange(pseudoSlg) {
            if (pseudoSlg) {
                this.$store.commit('setExportWorksDetailsInterestedPartiesCWR', 'yes')
            }
        },
        invalidateExportResult() {
            this.$store.commit('setExportWorksErrorArray', [])
            this.$store.commit('setExportWorksResultLink', null)
            this.$store.commit('setExportWorksResultGi', null)
            this.$store.commit('setExportWorksShowResult', false)
            this.$store.commit('setExportWorksHasError', false)
        },
        clearButtons() {
            this.invalidateExportResult()
            this.$store.commit('setExportWorksCWRCheckbox',[])

            // Reset mappings filter
            this.$store.commit('setSelectedMappingsDirectionsFilter', null)
            this.$store.commit('setSelectedMappingsDomainsFilter', null)

            // Reset publisher entries
            this.$store.commit('setExportWorksDetailsSelectedPublisherEntry', null)
        },
        start() {
            this.$store.dispatch('exportWorks')
        },
        getFileName() {
                let link = this.resultLink
                // let linkArr = link.split("/")
                let filename = link.substring(0, link.indexOf("&alvtoken")).replace(/^.*[\\\/]/, '')
                // return linkArr[linkArr.length - 1]
                return filename
        },
        downloadFile() {
            api.getFileFromALV(this.resultLink)
            this.$store.commit('setSnackbar', {
                type: 'success',
                msg: this.$t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        },
        previewFile() {
            openCwrPreview(this.resultLink)
        },
        getMappings() {
            this.$store.commit('setSelectedMappingsDomainsFilter', 'publishing_works')
            this.$store.dispatch('fetchMappingsByDomain')
        }
    },
    created() {
        this.$store.commit('setSocieties')
        this.$store.commit('setCountries')
        this.$store.commit('setExportWorksDetailsCwrSubmitter', )
    }
}
</script>